import React from 'react';
import ReactDOM from 'react-dom';
import './styles/styles.css';

import App from './components/App';


ReactDOM.render(<App/>, document.querySelector('#root'));